import { getJsonAsync, putJsonAsync } from './fetchConfig';

export const getAllCountries = () => getJsonAsync('countries');
export const getHighRiskCountries = () => getJsonAsync('/constants/high-risk-countries');

export const updateHighRiskCountry = values => putJsonAsync('/constants/high-risk-countries', values);

